module.exports = __webpack_public_path__ + "img/quickright-logo-white.37b60d36.png";